import { createComponent } from '@mtfe/sweet';
import Toast from '../Toast/script';
import tpl from './dom.html';
import style from './style.less';
import Dialog, { hideDialog } from '../common/Dialog/script';
import innerTpl from './innerTpl.html';

const hideLoginModal = () => {
    hideDialog();
};

/**
 * @param {Object} props 参数
 * @returns
 */
const NewLoginModal = (props = {}) => {
    const { loadLogin, loginSuccessCb, isRightClose, onClose, modalTitle = '领红包需要验证您的身份' } = props;
    if (!loadLogin) {
        throw new Error('Params loadLogin must be required!');
    }

    loadLogin('loignContainer', style.extraClass, {
        loginCompleteHandler: (info) => {
            if (info.user) {
                Toast({ message: '登录成功', position: 'center' });
                setTimeout(() => {
                    hideLoginModal();
                    loginSuccessCb && loginSuccessCb(info);
                }, 500);
            } else {
                Toast({ message: '登录失败，请稍后重试', position: 'center' });
            }
        },
    });

    const events = {};

    const loginContentData = {
        modalTitle,
    };

    const loginContent = createComponent(innerTpl, { data: loginContentData, style }, events);
    const data = {
        renderLoginDialog: Dialog({
            contentComponent: loginContent,
            isRightClose,
            onClose,
        }),
    };
    createComponent(tpl, { data });
};

export default NewLoginModal;
export { hideLoginModal };
